import { SingleTemplateCraftQueries } from '@core-mkt/shared/craft/craft-queries';
import type { CraftSiteTemplateMapping } from './craft-site-template-mapping';

const SITE_CODES = ['ACE', 'AA', 'AARP', 'DEC', 'INS', 'MTG', 'QA', 'IDS', 'HSP'];

export const CraftQueries: CraftSiteTemplateMapping[] = SITE_CODES.map((site) => ({
  site,
  queries: SingleTemplateCraftQueries,
}));
